<template>
  <LocationSelect
    label="Current physical address"
    v-model="profile.location.address"
    @input="handleLocationSelect"
    :toFront="toFront"
    @blur="submit"
    :loading="loading"
    @focus="focused = true"
    hint="This should be your street address"
    @keyup.enter="submit"
    :attach="attach"
    autofocus
  />
</template>

<script>
import LocationSelect from '@/components/selects/LocationSelect'

// Vue Component
export default {
  components: { LocationSelect },

  props: {
    value: {
      type: Object,
      default: () => ({ address: '' }),
    },
    toFront: { type: Boolean, default: () => false },
    attach: { type: Boolean, default: true },
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        location: { address: this.value.address },
      },
      // UX Improvements
      focused: false,
    }
  },
  methods: {
    handleLocationSelect(location) {
      if (!location) return
      this.profile.location.address = location.formatted_address || location.description
    },
    submit() {
      this.focused = false
      if (this.value.address !== this.profile.location.address) {
        this.loading = true
        this.$store.dispatch('candidate/profile/update', this.profile).then(() => {
          this.loading = false
          this.$emit('input')
        })
      }
    },
  },
}
</script>
